import { Dimension } from '../solucion/Dimension.entity';
import { Capa } from '../solucion/Capa.entity';
import { Solucion } from '../solucion/solucion.entity';
import { Router } from '@angular/router';

export class Diagnostico {
  constructor(
    public tipoDesconexionID: number,
    public titulo: string,
    public desconexiones: Desconexion[],
    public desconexionesID: number[],
    public solucionesID: number[],
    public soluciones: Solucion[],
    public dimension: Dimension,
    public dimensionID: number,
    public capa: Capa,
    public capaID: number,
    public etapa: Etapa,
    public etapaID: number,
    public rangoMayor: number,
    public rangoMenor: number,
) {}
    }

export class Desconexion {
    constructor(
      public desconexionID: number,
      public descripcion: string ,
      public resumen: string  ) {}
    }

export class Etapa {
      constructor(
        public etapaId: number,
        public descripcion: string,
        public leyenda: string,
        public leyenda2: string,
        public hasChild: boolean,
        public isCompleted: boolean ) {}
      }

export class DiagnosticoCliente {
  constructor(
    public diagnosticoID: number,
    public descripcion: string,
    public clienteId: number) {}
    }



// WEBPACK FOOTER //
// ./src/app/diagnostico/Diagnostico.entity.ts